module.exports = __webpack_public_path__ + "img/single_better.99202b67.svg";